export const STARTOFGAME = "Start of Game";
export const WAITFORCONNECTION = "wait for connection with server / opponent";
export const CREATINGOPTIONS = "creating game options";
export const CREATINGUI = "creating ui elements";
export const CREATINGPLAYERS = "creating players";
export const CREATINGPLAYEROPTIONS = "creating player options";
export const CHECKFIRSTTHROW = "check if this is the first throw of the game";
export const SETTINGSTARTPLAYER = "setting starting player";
export const PREPAREACTIVEPLAYER = "preparing active player for round";
export const WAITINGFORINPUT = "waiting for input";
export const WAITFORROUNDEND = "waiting for input of other player";
export const WINCHECK = "check if player has won with that throw";
export const WINCHECKSINGLE = "check if player has won with a single throw";
export const SETNEXTPLAYER = "setting the next player in the list";
export const ENDOFGAME = "End of Game";

export const STATEMACHINE = [
    STARTOFGAME,
    CREATINGOPTIONS,
    CREATINGPLAYERS,
    CREATINGPLAYEROPTIONS,
    WAITFORCONNECTION,
    CREATINGUI,
    CHECKFIRSTTHROW,
    SETTINGSTARTPLAYER,
    PREPAREACTIVEPLAYER,
    WAITINGFORINPUT,
    WINCHECK,
    SETNEXTPLAYER,
    ENDOFGAME
];

